import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "date-color" }
const _hoisted_2 = { class: "pa-2" }
const _hoisted_3 = { class: "mb-3" }

import moment from "moment/moment";
import {computed, reactive} from "vue";
import {useSettingsStore} from "@/api/store/settings";
import {useRouter} from "vue-router";
import {surveysService} from "@/api/services/surveys";
import RatingSlider from "@/components/custom/RatingSlider.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'DocumentSurveyView',
  setup(__props) {

const settingsStore = useSettingsStore();
const router = useRouter();

const state = reactive({
  survey: [] as any[],
})
const getQuestionsResponse = () => {
  

  surveysService.getQuestionsResponse(router.currentRoute.value.params.id as number).then((response) => {

    state.survey = [...response];
    router.currentRoute.value.meta.showTitleBar = true;
    router.currentRoute.value.meta.title = router.currentRoute.value.params.surveyName;

    
  });
}

const getSurveyCompletedDate = computed(() => {
  if (state.survey[0] === undefined) return;

  return moment(state.survey[0].client_survey.completed).format('DD MMM YYYY')
})


getQuestionsResponse()

return (_ctx: any,_cache: any) => {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_sheet = _resolveComponent("v-sheet")!
  const _component_v_textarea = _resolveComponent("v-textarea")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, {
    class: "px-0 pb-5 surveys",
    style: {"background-color":"#F0F0F0","position":"relative"}
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card_title, { class: "date-label mx-3" }, {
        default: _withCtx(() => [
          _cache[0] || (_cache[0] = _createTextVNode(" Entry: ", -1)),
          _createElementVNode("span", _hoisted_1, _toDisplayString(getSurveyCompletedDate.value), 1)
        ]),
        _: 1
      }),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.survey, (question, index) => {
        return (_openBlock(), _createBlock(_component_v_container, {
          key: `survey-${index}`,
          class: "px-6 py-0"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_sheet, { class: "border-rounded pa-3 mb-3" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("p", _hoisted_3, _toDisplayString(question?.questions?.title), 1),
                  _createVNode(RatingSlider, {
                    modelValue: question.answer,
                    "onUpdate:modelValue": ($event: any) => ((question.answer) = $event),
                    color: _unref(settingsStore).settings.primaryColor,
                    readonly: ""
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "color"])
                ])
              ]),
              _: 2
            }, 1024),
            (question?.questions?.enable_comments == 1)
              ? (_openBlock(), _createBlock(_component_v_textarea, {
                  key: 0,
                  value: question.comment,
                  class: "disable-pointer-events",
                  density: "compact",
                  "no-resize": "",
                  placeholder: "Add a Comment...",
                  rows: "1",
                  variant: "solo"
                }, null, 8, ["value"]))
              : _createCommentVNode("", true)
          ]),
          _: 2
        }, 1024))
      }), 128))
    ]),
    _: 1
  }))
}
}

})